/** The frame-source candidates offered for a cover (and the AI reference):
 *  what the editor preview shows, or the raw source-video frame. */
export type CoverFrameSource = 'preview' | 'video';

import { withStillCorsCacheKey } from './withStillCorsCacheKey';

type PlayerInputProps = Record<string, unknown>;

/**
 * Input props for rendering ONE still of the editor preview with
 * `renderStillOnWeb`, derived from the live Player's props.
 *
 * The Player plays through native HTML5 video (`playback: 'html5'`), which a
 * still renderer cannot capture; `'media'` switches the composition to
 * `@remotion/media` — the frame-accurate path the export uses. The still is
 * silent and drops editor-only chrome (safe-zone guides) and the live-player
 * callbacks. Everything the preview draws (layout, subtitles, layers, logo,
 * watermark) is kept, so the still matches what the user sees. Public
 * storage URLs are tagged (`withStillCorsCacheKey`) so the renderer's CORS
 * fetches never hit the Player's non-CORS cache entries.
 */
export function buildPreviewStillInputProps<P extends PlayerInputProps>(
  playerProps: P,
  { videoUrl }: { videoUrl?: string },
): P {
  return withStillCorsCacheKey({
    ...playerProps,
    ...(videoUrl ? { videoUrl } : {}),
    playback: 'media',
    previewPlaying: false,
    isMuted: true,
    volume: 0,
    showSafeZone: false,
    onMediaError: undefined,
    onPreviewBuffering: undefined,
    onPreviewMediaReady: undefined,
  });
}
